import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Scatter } from 'react-chartjs-2';
import { TextField } from '@totalsoft/rocket-ui';

export const OfferDecisionFinancedAssetsChartComponent = ({ t, data }) => {
  let serieses = () => {
    let datasets = [
      {
        label: t('OfferEdit.Decision.FinancedChart.BreakEven'),
        data: data.breakEvenPoints.map(p => ({ x: p.month, y: p.value })),
        borderColor: 'red',
        type: 'line',
        fill: false,
        showLine: false,
        pointHoverBackgroundColor: 'red',
        stacked: true,
        pointStyle: 'cross',
        pointHitRadius: 10,
        pointRadius: 10,
        pointBackgroundColor: 'red'
      },
      {
        label: t('OfferEdit.Decision.FinancedChart.MarketValueLabel'),
        data: data.assetValueDetails.map(p => ({ x: p.month, y: p.marketValue })),
        borderColor: 'blue',
        fill: false,
        type: 'line',
        showLine: true
      },
      {
        label: t('OfferEdit.Decision.FinancedChart.OutstandingLabel'),
        data: data.assetValueDetails.map(p => ({ x: p.month, y: p.outstanding })),
        borderColor: 'red',
        fill: false,
        type: 'line',
        showLine: true
      }
    ];
    data.assetValueDetails.forEach(a => {
      datasets.push({
        data: [
          { x: a.month, y: a.marketValue },
          { x: a.month, y: a.outstanding }
        ],
        value: a.ecart,
        label: `graph_${a.month}`,
        borderColor: 'pink',
        fill: false,
        type: 'line',
        showLine: true,
        borderDash: [5, 5],
        name: 'ecartGraph',
        pointHitRadius: 0,
        pointRadius: 0
      });
    });
    return datasets;
  };

  let options = {
    maintainAspectRatio: false,
    layout: {
      padding: {
        left: 0,
        right: 20,
        top: 20,
        bottom: 0
      }
    },
    animation: {
      duration: 1,
      onComplete: function (context) {
        var chartInstance = context.chart;
        var datasets = chartInstance.config.data.datasets;
        var ctx = chartInstance.canvas.getContext('2d');
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';
        ctx.fillStyle = '#8b2323';

        datasets.forEach(function (dataset, i) {
          if (dataset.name === 'ecartGraph') {
            var meta = chartInstance.getDatasetMeta(i);
            var pointY = meta.data.map(a => a.y).reduce((a, b) => a + b) / 2;
            meta.data.forEach(function (bar, index) {
              if (dataset.data[index].x !== dataset.data[index].y && dataset.data[index].x !== 0) {
                ctx.fillText(`${dataset.value}`, bar.x - 10, pointY + 5);
              }
            });
          }
        });
      }
    },
    plugins: {
      title: false,
      tooltip: true,
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          generateLabels: function (chart) {
            var labelsToShow = [];
            var data = chart.data;
            if (data.datasets.length) {
              data.datasets.forEach((a, index) => {
                if (a.label && !a.label.includes('graph_')) {
                  labelsToShow.push({ text: a.label, index: index, fillStyle: a.borderColor });
                }
              });
            }

            return labelsToShow;
          }
        }
      }
    },
    scales: {
      xAxis: {
        grid: {
          display: false,
          color: 'black',
          borderDash: [1, 5],
          zeroLineColor: 'rgb(0,0,0)',
          drawBorder: true,
          zeroLineWidth: 0
        },
        ticks: {
          fontColor: 'black',
          autoSkip: false,
          stepSize: 6
        },
        barPercentage: 0.2
      },
      yAxis: {
        grid: {
          display: false,
          color: 'black',
          borderDash: [1, 5],
          zeroLineColor: 'black',
          drawBorder: false,
          zeroLineBorderDash: [1, 5]
        },

        ticks: {
          fontColor: 'black'
        }
      }
    },
    elements: {
      line: {
        tension: 0
      }
    }
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Scatter
          data={{
            datasets: serieses()
          }}
          height={500}
          axisXTitle={t('OfferEdit.Decision.FinancedChart.axisXTitle')}
          axisYTitle={t('OfferEdit.Decision.FinancedChart.axisYTitle')}
          options={options}
          displayDataLabels={false}
        />
      </Grid>
      {data.dynamicExposureElements.length > 0 && (
        <Grid item container spacing={2}>
          {data.dynamicExposureElements.map(x => {
            return (
              <Grid key={x.id} item xs={12} sm={6} md={4}>
                <TextField disabled fullWidth value={x.elementAmount || 0} label={x.elementName} />
              </Grid>
            );
          })}
        </Grid>
      )}
    </Grid>
  );
};

OfferDecisionFinancedAssetsChartComponent.propTypes = {
  data: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(OfferDecisionFinancedAssetsChartComponent);
